import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import ButtonDesigned from '../../Buttons/ButtonDesigned';
import { ViewDocumentOverlay } from '../../ViewDocumentOverlay';
import { AttachFileErrorScreen } from '../ErrorComponents/uploadFileErrorScreen';
import {
  DEFAULT_APPROVED_FILE_FORMATS,
  DEFAULT_MAX_FILE_SIZE,
  fetchDocumentFromStorage,
  getDropzoneOrderConfig,
  handleRemoveSingleFile,
  IUploadErrorObject,
} from '../fileUploadUtils';
import React from 'react';

interface DocUploadPanelProps {
  uploadedDocumentPath?: string;
  setUploadedDocumentPath: (value: string) => void;
  bucketSavingLocation?: string;
  fileNameSuffix?: string;
  uploadTitle?: string;
  maxFileSizeInMb?: number;
  fileFormatAllowed?: string[];
  className?: string;
}

const NewDocUploadPanel: React.FC<DocUploadPanelProps> = ({
  uploadedDocumentPath,
  setUploadedDocumentPath,
  bucketSavingLocation = '/',
  fileNameSuffix = '',
  uploadTitle = 'Upload Signed Contract',
  maxFileSizeInMb = DEFAULT_MAX_FILE_SIZE,
  fileFormatAllowed = DEFAULT_APPROVED_FILE_FORMATS,
  className,
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isUploadError, setIsUploadError] = useState<IUploadErrorObject>({
    value: false,
    errorType: 'none',
  });
  const [fileUrl, setFileUrl] = useState('');

  useEffect(() => {
    if (uploadedDocumentPath) {
      fetchDocumentFromStorage(uploadedDocumentPath, (value: string) => setFileUrl(value));
    }
  }, [uploadedDocumentPath]);

  const getFileName = (fullPath: string) => {
    const parts = fullPath.split('/');
    return parts[parts.length - 1];
  };

  const dropzoneConfig = getDropzoneOrderConfig(
    uploadedDocumentPath ? [uploadedDocumentPath] : [],
    (value: string[]) => {
      setUploadedDocumentPath(value[0]);
    },
    setIsUploadError,
    bucketSavingLocation,
    fileNameSuffix,
    maxFileSizeInMb,
    fileFormatAllowed,
    false,
    (isLoading: boolean) => console.debug('loading', isLoading),
  );

  const { getRootProps: getRootProps1, getInputProps: getInputProps1 } = useDropzone(dropzoneConfig);

  return (
    <>
      <div
        {...getRootProps1({
          className: `flex max-w-max border-dashed border-1 rounded border-gray-700/40 p-[0.3rem] ${className} `,
        })}
      >
        <input {...getInputProps1()} />
        {showOverlay && (
          <ViewDocumentOverlay
            fileUrl={fileUrl}
            uploadedDocumentPath={uploadedDocumentPath || '1'}
            setShowOverlay={setShowOverlay}
          />
        )}
        {uploadedDocumentPath ? (
          <div className="flex">
            <div className="flex bg-gray-50 p-[0.3rem]">
              <img src={`/assets/icons/flat/doc.svg`} alt=""></img>
              <p className="m-0 text-xs rounded p-[0.25rem] text-gray-700 opacity-80">
                {getFileName(uploadedDocumentPath)}
              </p>
              <button title="remove current document">
                <img
                  className="h-[0.75rem] w-[0.75rem]"
                  src={`/assets/icons/flat/delete.svg`}
                  onClick={() =>
                    handleRemoveSingleFile(uploadedDocumentPath, (value: string) => {
                      setUploadedDocumentPath(value);
                    })
                  }
                  alt=""
                ></img>
              </button>
            </div>
            <ButtonDesigned
              type="button"
              onButtonClick={(e: any) => {
                e.preventDefault();
                setShowOverlay(true);
              }}
              style="outline"
              className="ms-[0.25rem]"
            >
              View
            </ButtonDesigned>
          </div>
        ) : (
          <div className="flex">
            <img className="h-7 w-7" src={`/assets/icons/colored/upload.svg`} alt="" />
            <p className="m-0 text-xs rounded p-[0.5rem] text-gray-700 opacity-80">{uploadTitle}</p>
            <ButtonDesigned type="button" onButtonClick={() => {}} style="outline">
              Browse
            </ButtonDesigned>
          </div>
        )}
      </div>
      {isUploadError.value && (
        <AttachFileErrorScreen
          errorType={isUploadError.errorType}
          setDisplayOverlay={(value: boolean) => setIsUploadError({ errorType: 'none', value: value })}
        />
      )}
    </>
  );
};

export default NewDocUploadPanel;
